export enum ProcedureStepType {
  Admitted = 'ADMITTED',
  WrIn = 'WR_IN',
  WrOut = 'WR_OUT',
  PreOpIn = 'PRE_OP_IN',
  BlockNerve = 'BLOCK_NERVE',
  ReadyForSurgeon = 'READY_FOR_SURGEON',
  ReadyForAnesthesia = 'READY_FOR_ANESTHESIA',
  SpinalTimeout = 'SPINAL_TIMEOUT',
  ReadyForOR = 'READY_FOR_OR',
  PreOpOut = 'PRE_OP_OUT',
  OrIn = 'OR_IN',
  AnestheticStart = 'ANESTHETIC_START',
  TimeOut = 'TIME_OUT',
  AntibioticTime = 'ANTIBIOTIC_TIME',
  ReadyForSurgery = 'READY_FOR_SURGERY',
  PhysicianIn = 'PHYSICIAN_IN',
  OperationStart = 'OPERATION_START',
  CallNextPatient = 'CALL_NEXT_PATIENT',
  Closing = 'CLOSING',
  SurgeonLeftOR = 'SURGEON_LEFT_OR',
  DressingOn = 'DRESSING_ON',
  OperationEnd = 'OPERATION_END',
  AnestheticEnd = 'ANESTHETIC_END',
  OrOut = 'OR_OUT',
  CleaningCompleted = 'CLEANING_COMPLETED',
  OrRoomReady = 'OR_ROOM_READY',
  PacuIn = 'PACU_IN',
  TransferredToChair = 'TRANSFERRED_TO_CHAIR',
  TransferredToPT = 'TRANSFERRED_TO_PT',
  PTComplete = 'PT_COMPLETE',
  PacuReadyToLeave = 'PACU_READY_TO_LEAVE',
  PacuOut = 'PACU_OUT',
  PostOpIn = 'POSTOP_IN',
  PostOpOut = 'POSTOP_OUT',
  Discharged = 'DISCHARGED',
}

export interface ProcedureStep {
  id: number;
  name: string;
  type: ProcedureStepType;
  order: number;
  timestamp?: string;
  /** Effective measurement (id and timestamp from the same row); only queried by the OR tablet. */
  measurement?: { id: number; timestamp: string } | null;
  options?: unknown;
}
